/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DashboardCtlDto, DashboardDetailCtlDto } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Dashboard<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags /dashboard
	 * @name DoGetDashboard
	 * @summary 대시보드 메인 (추가: 2023.08)
	 * @request GET:/dashboard
	 * @secure
	 * @response `200` `DashboardCtlDto` [code]<br />server.error: 서버 오류<br /><br />
	 * @response `500` `DashboardCtlDto` 서버 오류
	 */
	doGetDashboard = (params: RequestParams = {}) =>
		this.http.request<DashboardCtlDto, DashboardCtlDto>({
			path: `/dashboard`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /dashboard
	 * @name DoGetDashboardAppId
	 * @summary 대시보드 상세 (추가: 2023.08)
	 * @request GET:/dashboard/{appId}
	 * @secure
	 * @response `200` `DashboardDetailCtlDto` [code]<br />not.found.record: 앱을 찾을 수 없음<br />server.error: 서버 오류<br /><br />
	 * @response `500` `DashboardDetailCtlDto` 서버 오류
	 */
	doGetDashboardAppId = (appId: number, params: RequestParams = {}) =>
		this.http.request<DashboardDetailCtlDto, DashboardDetailCtlDto>({
			path: `/dashboard/${appId}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
